import Box from '@material-ui/core/Box';
import { pageUrls } from 'globalconfig/constants/keys';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import PropTypes from 'prop-types';
import React, { lazy, useState } from 'react';
import { getELDStatusIcon, overRideColumns } from './config';
import { checkServiceProvider } from './serviceProviderConfig';

const layout = window?.$environment?.CURRENT_LAYOUT;
const SERVICE_PROVIDER = window?.$environment?.SERVICE_PROVIDER;
const Breadcrumb = lazy(() => import(`globalcomponents/Breadcrumb`));
const GoogleMap = lazy(() => import(`globalcomponents/GoogleMap/${layout}`));
const Search = lazy(() => import(`globalcomponents/UI/SimpleSearch/${layout}`));
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));
const Modal = require(`globalcomponents/UI/Modal/${layout}`).default;

const Index = ({ theme, filters, ...contentProps }) => {
  return (
    <Box style={{ ...theme.palette.contentStyle }}>
      <Breadcrumb filters={filters} />
      <Component {...contentProps} />
    </Box>
  );
};
export default Index;

const Component = ({
  changeRequest,
  request,
  i18n,
  driverStatusList,
  history,
  Styled,
  driverStatusFilteredList,
  totalElements,
  pagination,
  setPagination,
}) => {
  const [modal, setModal] = useState(false);

  const selectChange = (e) => {
    changeRequest({ search: e });
    setPagination(true);
  };

  const generateRows = () => {
    const updatedList = driverStatusFilteredList.map((item, index) => {
      const rowItem = { ...item };
      rowItem.currentStatus = item.dailyLogId ? (
        <Icon
          src={mediaUrls.logsIcon}
          tableicon
          onClick={() => history.push(pageUrls.logsView.replace(':id', item.dailyLogId))}
        ></Icon>
      ) : (
        '-'
      );
      rowItem.driveTimeRemaining = `${rowItem.driveTimeRemaining} hours`;
      rowItem.onDutyTimeRemaining = `${rowItem.onDutyTimeRemaining} hours`;
      rowItem.dutyCycleRemaining = `${rowItem.dutyCycleRemaining} hours`;
      if (checkServiceProvider('override_eldState', SERVICE_PROVIDER, false)) {
        rowItem.eldState = (
          <a
            onClick={() => {
              if (rowItem.dailyLogUrl) history.push(rowItem.dailyLogUrl.replace('.', '/'));
              else setModal(true);
            }}
          >
            <div className={getELDStatusIcon(rowItem.eldState)} />
          </a>
        );
      }
      return rowItem;
    });
    return updatedList;
  };

  return (
    <>
      <Styled.Wrapper>
        <Styled.SearchWrapper>
          <Search default={[...driverStatusList]} onChange={(e) => selectChange(e)} width="35%" id="driver_Status_1" />
        </Styled.SearchWrapper>
        {checkServiceProvider('override_GoogleMap', SERVICE_PROVIDER, false) && (
          <Styled.MapWrapper>
            <GoogleMap type={'driverStatusMap'} height={'400px'} data={driverStatusList} />
          </Styled.MapWrapper>
        )}
        <Styled.TableWrapper>
          <Icon
            src={mediaUrls?.refreshIcon}
            onClick={() => selectChange("")}
            tooltip={i18n.t('common.refresh')}
          />
          <Table
            type="server"
            title=""
            changeRequest={changeRequest}
            baseRequest={request}
            itemsPerPage={10}
            totalRecords={totalElements}
            data={generateRows()}
            columns={overRideColumns}
            emptyMessage={i18n.t('common.tableEmptyMessage')}
            actions={[]}
            i18n={i18n}
            pageinationReset={pagination}
            pagenationClicked={(e) => {
              setPagination(!e);
            }}
          />
        </Styled.TableWrapper>
      </Styled.Wrapper>
      <Modal
        open={modal}
        setOpen={() => setModal((m) => !m)}
        withCloseIcon
        alignItemsLeft
        noDataPopup
        data={{
          header: '',
          content: () => <div>No Logs available</div>,
        }}
      />
    </>
  );
};

Component.propTypes = {
  list: PropTypes.object.isRequired,
  filterSuccess: PropTypes.func.isRequired,
};
